import React, { useState } from 'react';
import {Invoices} from './Invoices';
import {PaymentPreference} from './PaymentPreference';
import {PlanDetails} from './PlanDetails';
import {SubscribedUserPayamentTitle} from './SubscribedUserPaymentTitle';
import languageFile from '../../../../public/languages/Translation';

const BILLING_TABS = [
	{ id: '1', label: languageFile[localStorage.getItem('language')]["24111"] || 'Plan Details' },
	{ id: '2', label: 'Payment Preferences' },
	{ id: '3', label: 'Invoices' },
];

export const SubscribedUserPaymentWrapper = ({
	paymentDetails,
	getHostPage,
	cancelSubscription,
	handleCancel,
	handleOk,
	cancelConfirmationModal,
	cancelConfirmation,
	getAddonDetails,
	invoicesData,
	getInvoicesList,
	ownerUpdatedMessage,
	openPaymentModal,
	ownerUpdateResponseMessage,
	invalidEmail,
	changeOwner,
	changePayerDetailsModal,
	changeEmailModal,
	updatePayerEmail,
	payerEmail,
	cancelSubscriptionResponseMessage,
	isSubscriptionCancelled,
	reActiveConfirmation
}) => {
	const [activeTab, setActiveTab] = useState('1');

	return (
		<div>
			<SubscribedUserPayamentTitle
				navigationData={BILLING_TABS}
				activeMainTab={activeTab}
				onTabClick={setActiveTab}
			/>
			<div className='payment-page-outer'>
				<div className='payment-plans'>
					{activeTab === '1' && (
						<PlanDetails
							paymentDetails={paymentDetails}
							getAddonDetails={getAddonDetails}
							cancelConfirmationModal={cancelConfirmationModal}
							cancelConfirmation={cancelConfirmation}
							reActiveConfirmation={reActiveConfirmation}
							cancelSubscription={cancelSubscription}
							handleCancel={handleCancel}
							isSubscriptionCancelled={isSubscriptionCancelled}
							cancelSubscriptionResponseMessage={cancelSubscriptionResponseMessage}
							handleOk={handleOk}
						/>
					)}
					{activeTab === '2' && (
						<PaymentPreference
							paymentDetails={paymentDetails}
							getHostPage={getHostPage}
							changeEmailModal={changeEmailModal}
							openPaymentModal={openPaymentModal}
							updatePayerEmail={updatePayerEmail}
							payerEmail={payerEmail}
							invalidEmail={invalidEmail}
							handleCancel={handleCancel}
							changeOwner={changeOwner}
							handleOk={handleOk}
							changePayerDetailsModal={changePayerDetailsModal}
							ownerUpdatedMessage={ownerUpdatedMessage}
							ownerUpdateResponseMessage={ownerUpdateResponseMessage}
						/>
					)}
					{activeTab === '3' && (
						<Invoices
							getInvoicesList={getInvoicesList}
							invoicesData={invoicesData}
						/>
					)}
				</div>
			</div>
		</div>
	);
};
